<template>
    <div class="login px-1 pt-5"> 
        <div class="x p-3" v-if="!loginStatus">
            <div class="h2 text-center py-4 text-primary">
                Login
            </div>
            <div>
                <input type="password" class="form-control form-control-lg text-center" v-model="pass">
            </div>
            <button class="btn btn-primary btn-lg mt-3 w-100" @click="appLogin">เข้าสู่ระบบ</button>
        </div>
        <div class="p-3" v-else>
            <select class="form-select form-select-lg" v-model="officer_id" ref="officer_choice" @change="getSelectedText">
                <option value="0">-เลือกชื่อ-</option>
                <option v-for="officer in officerList" :value="officer.id" :key="officer.id">{{officer.pname+officer.fname +' '+officer.lname}}</option>
            </select>
            <button class="btn btn-primary btn-lg mt-3 w-100" @click="appLoginOfficer">ตกลง</button>
        </div>
    </div>
</template>

<script>

import axios from 'axios'
export default {
    data (){
        return {
            officer_id:0,
            device_id:'',
            pass:'',
            loginStatus:false,
            officerList: [],
            selectedText: '',
        }
    },
    methods : {
        async appLogin () {
            if(this.pass.trim() == ""){
                this.showAlert('กรุณากรอกรหัสผ่าน','error')
            }else{
                try {
                    let res = await axios.post('/api/adddevice',{pass:this.pass,device_id:this.device_id})
                    if(res.data.status == 'success'){
                        console.log(res.data)
                        localStorage.setItem('device_id',this.device_id)
                        console.log('device_idi',localStorage.getItem('device_id'))
                        this.loginStatus = true
                        this.getOfficer()
                    }else{
                        this.showAlert('รหัสผ่านไม่ถูกต้อง','error')
                       
                    }
                } catch (error) {
                    console.error("api error: ",error)
                }
            }
        },
        getDeviceId () {
            try {
                this.device_id = this.generateDeviceId()
                // this.device_id = Math.random().toString(36)
                // localStorage.setItem('device_id',this.device_id)
                // console.log('device_id',this.device_id) 
            } catch (error) {
                alert(error)
                
            }
        },
        showAlert(txt,type) {
            this.$swal.fire({
                title: txt,
                text: 'กรุณาตรวจสอบ',
                icon: type,
                confirmButtonText: 'ตกลง',
            });
        },
        async getOfficer () {
            
            try {
                let res = await axios.post('/api/getofficer',{device_id:localStorage.getItem('device_id')})
                console.log(res.data);
                if(res.data.status == 'success'){
                    this.officerList = res.data.data
                }
            } catch (error) {
                console.log('Error: ',error)
            }
        },
        async appLoginOfficer () {
            if(this.officer_id != 0){
                let res = await axios.post('/api/addofficer',{officer_id:this.officer_id,device_id:this.device_id})
                if(res.data.status == "success"){
                    
                    
                    this.login()
                }else{
                    this.showAlert('ไม่สามารถเข้าสู่ระบบได้','error',res.message)
                }

            }else{
                this.showAlert('กรุณาเลือกชื่อ','error')
            }
        },
        getSelectedText() {
            const select = this.$refs.officer_choice;
            this.selectedText = select.options[select.selectedIndex].text;
        },
        generateDeviceId() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                const r = Math.random() * 16 | 0
                const v = c === 'x' ? r : (r & 0x3 | 0x8)
                return v.toString(16)
            })
        },
        async login(){
            try {
                let res = await axios.post('/api/login', { device_id:  this.device_id, officer_id: this.officer_id })
                console.log(res)
                if(res.data.status == 'success'){
                    let newToken = res.data.token
                    localStorage.setItem('officer_id', this.officer_id)
                    localStorage.setItem('officer_name', this.selectedText)
                    localStorage.setItem('jwt_token', newToken)
                    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
                    this.$router.push('/')
                }
            } catch (error) {
                console.log('Error: ',error)
                this.showAlert('ไม่สามารถเข้าสู่ระบบได้','error',res.message)
                
            }
        }
    },
    created() {
        this.getDeviceId()
       
        
    }
}
</script>

